import {
	SET_ACCOUNT_URL,
	SET_ACCOUNT_NAME,
	SET_DEALER_CODE
} from '../actions/types';

export default function accountInfo(state = {}, action = null) {
	if (!action.error && action.payload && action.type) {
		switch (action.type) {
			case SET_ACCOUNT_URL:
				return { ...state, url: action.payload };
			case SET_ACCOUNT_NAME:
				return { ...state, name: action.payload };
			case SET_DEALER_CODE:
				return { ...state, dealerCode: action.payload };
			default:
				break;
		}
	}
	return state;
}
